<template>
    <div>
        <h3>{{title}}</h3>
        <div class="row">
            <div class="form-group col-md-4">
                <label class="font-weight-bold">{{ $t('address.country') }}</label>
                <input type="text" class="form-control" readonly :value="isEnVersion ? address.countryEn : address.country">
            </div>
            <div class="form-group col-md-8">
                <label class="font-weight-bold">{{ $t('address.settlement') }}</label>
                <input type="text" class="form-control" readonly :value="isEnVersion ? address.settlementEn : address.settlement">
            </div>
            <div class="form-group col-md-4">
                <label class="font-weight-bold">{{$t('address.postCode') }}</label>
                <input type="text" class="form-control" readonly v-model="address.postCode">
            </div>
            <div class="form-group col-md-4">
                <label class="font-weight-bold">{{ $t('address.street') }}</label>
                <input type="text" class="form-control" readonly v-model="address.street">
            </div>
            <div class="form-group col-md-4">
                <label class="font-weight-bold">{{ $t('address.streetNum') }}</label>
                <input type="text" class="form-control" readonly v-model="address.num">
            </div>
        </div>
    </div>
</template>

<script>
    import { AddressDetails } from '@/models/models';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            address: AddressDetails,
            title: String
        },
        computed: {
            ...mapGetters(['isEnVersion'])
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
